import { FlatfileListener } from '@flatfile/listener';
import api from '@flatfile/api';
// import { recordHook } from "@flatfile/plugin-record-hook";

import { postFlatfilePlatformBatch } from 'store/actions/contacts';
import { store } from 'App';

export const spaceListener = listUuid =>
  FlatfileListener.create(listener => {
    listener.on('**', event => {
      console.log(`Received event: ${event.topic}`);
    });

    // listener.use(
    //   recordHook("contacts", (record) => {
    //     const firstName = record.get("firstName");
    //     console.log({ firstName });
    //     record.set("lastName", "Rock");
    //     return record;
    //   })
    // );

    // listener.use(
    //   recordHook("contacts", (record) => {
    //     // Your logic to check if the 'external_id' is unique
    //     // For example, querying your database to ensure uniqueness
    //     const isUnique = /* your uniqueness check logic here */;

    //     if (!isUnique) {
    //       record.addError("external_id", "This field must be unique. Muster text.");
    //     }

    //     return record;
    //   })
    // );

    listener.filter({ job: 'workbook:submitActionFg' }, configure => {
      configure.on('job:ready', async ({ context: { jobId, spaceId, workbookId } }) => {
        try {
          await api.jobs.ack(jobId, {
            info: 'Getting started.',
            progress: 10,
          });

          const params = {
            jobId,
            spaceId,
            status: 'complete',
            workbookId,
          };

          await store.dispatch(postFlatfilePlatformBatch(listUuid, params));

          await api.jobs.complete(jobId, {
            outcome: {
              acknowledge: true,
              message:
                'Your upload is being processed! Please allow a few minutes for contacts to appear in your lists.',
              next: {
                type: 'wait',
              },
            },
          });
        } catch (error) {
          console.error('Error:', error.stack);

          await api.jobs.fail(jobId, {
            outcome: {
              message: 'This job encountered an error.',
            },
          });
        }
      });
    });
  });
